<template>
  <aside class="app-sidebar" v-if="usuario">
    <div class="sidebar-brand">
      <img src="@/assets/ofertacaracas.jpg" alt="Ofertas Caracas">
      <span>Ofertas Caracas</span>
    </div>

    <nav class="sidebar-nav">
      <router-link class="sidebar-item" :to="{ path: '/' }" exact-active-class="active" @click.native="cerrarMenuMovil">
        <b-icon icon="view-dashboard" />
        <span>Inicio</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/inventario' }" active-class="active" @click.native="cerrarMenuMovil" v-if="permisos['vistas.inventario']">
        <b-icon icon="chart-bar-stacked" />
        <span>Inventario</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/marcas-y-categorias' }" active-class="active" @click.native="cerrarMenuMovil" v-if="permisos['vistas.marcas_categorias']">
        <b-icon icon="archive" />
        <span>Marcas y categorías</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/almacenes' }" active-class="active" @click.native="cerrarMenuMovil" v-if="permisos['vistas.almacenes']">
        <b-icon icon="warehouse" />
        <span>Almacenes</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/reconciliacion-inventario' }" active-class="active" @click.native="cerrarMenuMovil" v-if="permisos['productos.agregar_existencia']">
        <b-icon icon="clipboard-check-outline" />
        <span>Reconciliar inventario</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/realizar-venta' }" active-class="active" @click.native="cerrarMenuMovil" v-if="permisos['vistas.vender']">
        <b-icon icon="cash-fast" />
        <span>Vender</span>
      </router-link>

      <div class="sidebar-label" v-if="reportes">Reportes</div>

      <router-link class="sidebar-item" :to="{ path: '/reporte-ventas' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.ventas']">
        <b-icon icon="cash-register" />
        <span>Ventas</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/reporte-cuentas' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.cuentas']">
        <b-icon icon="wallet" />
        <span>Cuentas</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/reporte-apartados' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.apartados']">
        <b-icon icon="wallet-travel" />
        <span>Apartados</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/reporte-cotizaciones' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.cotizaciones']">
        <b-icon icon="ticket-outline" />
        <span>Cotizaciones</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/deliveries' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.deliveries']">
        <b-icon icon="truck-delivery" />
        <span>Deliveries</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/choferes' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.choferes']">
        <b-icon icon="card-account-details" />
        <span>Choferes</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/historial' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.historial']">
        <b-icon icon="clipboard-text-clock" />
        <span>Movimientos</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/proveedores' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.proveedores']">
        <b-icon icon="factory" />
        <span>Proveedores</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/cierre-caja' }" active-class="active" @click.native="cerrarMenuMovil" v-if="reportes && permisos['vistas.cierres']">
        <b-icon icon="cash-register" />
        <span>Cierres de caja</span>
      </router-link>

      <div class="sidebar-label" v-if="configuracion">Configuración</div>

      <router-link class="sidebar-item" :to="{ path: '/metodos' }" active-class="active" @click.native="cerrarMenuMovil" v-if="configuracion && permisos['vistas.metodos']">
        <b-icon icon="wallet" />
        <span>Métodos de pago</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/usuarios' }" active-class="active" @click.native="cerrarMenuMovil" v-if="configuracion && permisos['vistas.usuarios']">
        <b-icon icon="account" />
        <span>Usuarios</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/roles' }" active-class="active" @click.native="cerrarMenuMovil" v-if="configuracion && permisos['vistas.roles']">
        <b-icon icon="cog" />
        <span>Roles</span>
      </router-link>

      <router-link class="sidebar-item" :to="{ path: '/clientes' }" active-class="active" @click.native="cerrarMenuMovil" v-if="permisos['vistas.clientes']">
        <b-icon icon="account-supervisor" />
        <span>Clientes</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <div class="sidebar-user">
        <b-icon icon="account-circle" />
        <span>{{ usuario.usuario }}</span>
      </div>
      <button class="sidebar-logout" @click="salir">
        <b-icon icon="logout" />
        <span>Salir</span>
      </button>
    </div>
  </aside>
</template>
<script>
import HttpService from '@/Servicios/HttpService'

export default {
  name: "EncabezadoComponent",
  props: ['usuario', 'permisos'],

  methods: {
    async salir() {
      await HttpService.obtenerConConsultas('usuarios.php', { accion: 'cerrar_sesion' })
      this.$emit('cierre')
    },

    cerrarMenuMovil() {
      const toggle = document.getElementById('sidebar-toggle')
      if (toggle) toggle.checked = false
    },
  },

  computed: {
    configuracion() {
      const configuraciones = ['metodos', 'usuarios', 'roles']
      return configuraciones.some(config => this.permisos[`vistas.${config}`])
    },

    reportes() {
      const reportes = ['ventas', 'cuentas', 'apartados', 'cotizaciones', 'deliveries', 'choferes', 'movimientos', 'proveedores', 'cierres']
      return reportes.some(reporte => this.permisos[`vistas.${reporte}`])
    },
  },
}
</script>
